import { api } from './api';
import type { AxiosError } from 'axios';
import { createEnhancedError } from '../utils/error-handling';

export interface PlanUsageStats {
  planTier: string;
  properties: {
    used: number;
    max: number;
  };
  storage: {
    usedBytes: number;
    maxBytes: number;
  };
}

const handleBillingError = (error: AxiosError): never => {
  throw createEnhancedError(error);
};

export const billingApi = {
  getUsage: async (): Promise<PlanUsageStats> => {
    try {
      const response = await api.get<PlanUsageStats>('/billing/usage');
      if (response.data.success && response.data.data) {
        return response.data.data;
      }
      throw new Error('Failed to fetch plan usage');
    } catch (error) {
      return handleBillingError(error as AxiosError);
    }
  },
};
